import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllBooks = (page , limit ) => async (dispatch) => {
    try {

        dispatch({ type: 'get_all_books_request' });


        const { data } = await axios.get(`${BaseUrl}/books`, {
            params: {
                page,
                limit,
            
            },
        });

        dispatch({
            type: 'get_all_books_success',
            payload: {
                books: data.books,
                pagination: data.pagination, 
            },
        });

    } catch (error) {
        dispatch({
            type: "get_all_books_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getFillterBooks = (page , limit,titleAr,titleEn,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_books_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/books/filter`,{
            params: {
                page,
                limit,
                titleAr,
                titleEn,
                date
            },
            withCredentials: true,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_books_success',
            payload: {
                books: data.books,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_books_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};


export const getBook = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_book_request' });

        const { data } = await axios.get(`${BaseUrl}/books/${id}`);
        console.log("data",data);
        dispatch({ type: 'get_book_success' ,payload:data.book});

    } catch (error) {
        dispatch({
            type: "get_book_error",
            payload: error.response.data.message,
          });
    }
}